import { useCallback } from 'react'

import { observer } from 'mobx-react-lite'
import { SettlementFragmentOverview, ViewDataRowFragment } from 'types/graphql'

import Page from 'src/components/shared/Page/Page'
import TableViewBuilder from 'src/components/TableViewBuilder'
import { useTableViewManager } from 'src/fetch/views/use-table-view-manager'

const SettlementsPage = () => {
  const getDataFromRow = useCallback((row: ViewDataRowFragment) => row.settlement, [])
  const tableViewState = useTableViewManager({ viewType: 'SettlementForStaff' })

  return (
    <Page>
      <Page.Header title="Settlements" />
      <Page.Content>
        <TableViewBuilder<SettlementFragmentOverview>
          emptyStateMessage="No settlements found"
          getDataFromRow={getDataFromRow}
          tableViewState={tableViewState}
        />
      </Page.Content>
    </Page>
  )
}

export default observer(SettlementsPage)
